import Lockr from 'lockr'
import { apiGetCanteenList } from '@/api'

export default {

  setUserinfo ({ commit }, userinfo) {
    commit('setUserinfo', userinfo)
  },
  clearUserinfo ({ commit }) {
    commit('clearUserInfo')
    Lockr.set('userinfo', null)
  },
  getCanteenList ({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await apiGetCanteenList()
        commit('setCanteenList', res.canteen)
        return resolve(true)
      } catch (e) {
        return reject(e)
      }
    })
  }
}
